import type {
  Response,
  AssignedApplicantResponse,
} from '@/lib/apollo/query/getAssignedApplicants/query'

import type { TransformedAssignedApplicantData, TransformedData } from './types'

export const toTransformedAssignedApplicantData = (
  assignedApplicant: AssignedApplicantResponse,
): TransformedAssignedApplicantData => ({
  ...assignedApplicant,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getAssignedApplicants,
        results: response.getAssignedApplicants.results.map(
          toTransformedAssignedApplicantData,
        ),
      }
